import { Badge } from "@devhop/ui";
import { GripVertical } from "lucide-react";
import { useEffect, useRef } from "react";
import { useDrag } from "react-dnd";
import type { UserWithAssignmentDTO } from "@/modules/assign-position/domain/contracts";

type DraggableEmployeeProps = {
  employee: UserWithAssignmentDTO;
  canManage: boolean;
};

export function DraggableEmployee({
  employee,
  canManage,
}: DraggableEmployeeProps) {
  const [{ isDragging }, drag] = useDrag({
    type: "employee",
    item: { userId: employee.id },
    canDrag: canManage,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (canManage && divRef.current) {
      drag(divRef.current);
    }
  }, [drag, canManage]);

  const name = employee.name;
  const email = employee.email;
  const hasPosition = !!employee.currentPositionId;

  return (
    <div
      ref={divRef}
      className={`flex flex-col ${isDragging ? "opacity-50" : ""}`}
    >
      <div className="flex items-center gap-2">
        {canManage && (
          <GripVertical className="h-4 w-4 cursor-grab text-muted-foreground" />
        )}
        <span className="text-sm">{name || "-"}</span>
        {!hasPosition && (
          <Badge variant="outline" className="text-xs">
            ບໍ່ມີຕໍາແໜ່ງ
          </Badge>
        )}
      </div>
      {email && <span className="text-muted-foreground text-xs">{email}</span>}
    </div>
  );
}
